<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <table class="table mt-5">
            <thead>
                <tr>
                    <th scope="col">File</th>
                    <th scope="col">Uploaded</th>
                    <th scope="col">Processing start</th>
                    <th scope="col">Processing stop</th>
                    <th scope="col">Location</th>
                    <th scope="col">...</th>
                </tr>
            </thead>
            <tbody v-if="loading == true">
                <tr>
                    <td colspan="5">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr v-for="(f, idx) in files" :key="'files' + idx">
                    <td><a href="javascript:void(0)" v-on:click="handleDownloadClick(f.id)">{{f.originalFilename}}</a></td>
                    <td>{{f.dateCreated}}</td>
                    <td>{{f.startedAt}}</td>
                    <td>{{f.finishedAt}}</td>
                    <td>{{f.originalLocation}}</td>
                    <td>
                        <!--<a href="javascript:void(0)">View Rows</a><br/>-->
                        <router-link exact-active-class="active"
                                     :to="buildRouterLink(f)">
                            View Rows
                        </router-link>
                    </td>
                </tr>
            </tbody>
        </table>
        <b-pagination v-model="pageNumber"
                      :total-rows="totalRecords"
                      :per-page="pageSize"
                      aria-controls="my-table"
                      pills>
        </b-pagination>
        <hr />

    </div>
</template>

<script>
    import PageHeader from '@/components/PageHeader.vue'

    import axios from 'axios'
    import { API_BASE_URL } from '../globalVar'

    let indexOfObject = function (array, prop, value) {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][prop] === value) {
                return i;
            }
        }
        return -1;
    }

    export default {
        name: 'PartnerImports',
        components: {
            PageHeader
        },
        data: () => {
            return {
                pageHeader: {
                    title: 'Settlement Option Partner Imports',
                },
                loading: false,
                files:[],
                pageNumber: 1
            }
        },
        watch: {
            pageNumber: function (newVal, oldVal) {
                this.search()
            }
        },
        computed: {
            isLoading() {
                return false
            },
            dataList() {
                return this.$store.getters.claimsList
            },
            totalRecords() {
                if (this.files && this.files.length > 0) {
                    let firstRow = this.files[0]
                    if (firstRow) {
                        return firstRow.totalRecords
                    }
                }
                return 1 // DEFAULT
            },
            pageSize() {
                if (this.files && this.files.length > 0) {
                    let firstRow = this.files[0]
                    if (firstRow) {
                        return firstRow.pageSize
                    }
                }
                return 10 // DEFAULT
            },
            fileUrl() {
                return '/api/admin/v1/partnerimport/download/'
            }
        },
        methods: {
            buildDateRange(id) {

                let formatDate = (dte) => {

                    if (!(dte instanceof Date)) {
                        dte = new Date()
                    }

                    return dte.getFullYear() + '-' + String(dte.getMonth() + 1).padStart(2, '0') + '-' + String(dte.getDate()).padStart(2, '0')
                }

                let today = new Date()
                let startDate = formatDate(today)
                let endDate = startDate + ' 23:59:59'
                switch (id) {
                    case 1001:
                        // eslint-disable-next-line no-case-declarations
                        let dte1 = new Date()
                        dte1.setDate(dte1.getDate() - 7)
                        startDate = formatDate(dte1)
                        break;
                    case 1002:
                        // eslint-disable-next-line no-case-declarations
                        let dte2 = new Date()
                        dte2.setDate(dte2.getDate() - 28)
                        startDate = formatDate(dte2)
                        break;
                    default:
                    //startDate = startDate
                }
                return { startDate, endDate }
            },
            buildRouterLink(obj) {
                return {
                    name: 'partnerimportrows',
                    params: {
                        file: obj.id,
                        page: 1
                    }
                }
            },
            search() {
                this.loading = true
                this.getSupplierImportFiles({ pageNumber: this.pageNumber, pageSize: this.pageSize })
                    .then((res) => {
                        let { data, messages, pagination } = res.data
                        if (data) {
                            this.files = data
                        }
                    })
                    .catch((err) => {
                        console.error(err)
                    })
                    .finally(() => this.loading = false)
            },
            getSupplierImportFiles(payload) {
                let baseUrl = API_BASE_URL
                return axios.post(baseUrl + '/api/admin/v1/partnerimport/files', payload)
            },
            handleDownloadClick(payload) {
                let baseUrl = API_BASE_URL
                return axios.get(baseUrl + '/api/admin/v1/partnerimport/key')
                    .then(response => {
                        console.log(this.fileUrl + payload + '/' + response.data)
                        window.open(
                            this.fileUrl + payload + '/' + response.data,
                            '_blank'
                        )
                    })
            }
        },
        beforeMount() {
            this.search()
        }
    }
</script>

<style>
</style>
